import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=3b22c3ae&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=3b22c3ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports